export default __webpack_public_path__ + "static/media/slowdeathstrike2.b83af415.png";